import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from '../../../utils/createSignedRequest';
import { API_URL } from './utils/constants';

/**
 * The caller's upcoming (not-yet-ended, non-cancelled) meetings across the
 * threads it names — one call, so the app can arm reminders on load without
 * opening each chat. Same meeting shape as getMeetings (carries `window`).
 *
 * `withinHours` optionally bounds how far ahead to look. Reminders only care
 * about the next few minutes, so passing a small window keeps the payload cheap
 * once recurring series have materialized many future occurrences; omit it for
 * the full not-yet-ended list.
 *
 * Asks for `{ meetings, coverage }` — which threads were read, over which
 * window. An API that predates it ignores the flag and answers the bare array,
 * so callers must accept both.
 */
export const getUpcomingMeetings = async (threadIds, { withinHours } = {}) => {
  const apiPath = `chat/get-upcoming-meetings`;
  const body =
    withinHours != null
      ? { threadIds, withinHours, withCoverage: true }
      : { threadIds, withCoverage: true };
  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body), // aws4 looks for body; axios for data
    data: body,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
